// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import documentStatusEntity from './entities/document-status.json';
import documentStatusMenu from '../pages/document-status/menu.json';
import documentStatusFullForm from '../pages/document-status/forms/full.json';
import documentStatusContextForm from '../pages/document-status/forms/context.json';
import documentStatusMiniForm from '../pages/document-status/forms/mini.json';
import documentStatusLookupForm from '../pages/document-status/forms/lookup.json';
import documentStatusTableView from '../pages/document-status/views/table.json';
import documentStatusDashboardView from '../pages/document-status/views/dashboard.json';

/** Тип запису «Статус документа» зі сторінками пакета: меню, форми та подання з pages/document-status/. */
export const documentStatusDefinition: IRecordTypeDefinition = {
  ...documentStatusEntity,
  views: assembleViewSet({
      table: documentStatusTableView,
      dashboard: documentStatusDashboardView,
  }),
  form: documentStatusFullForm,
  forms: { full: documentStatusFullForm, context: documentStatusContextForm, mini: documentStatusMiniForm, lookup: documentStatusLookupForm },
  menu: documentStatusMenu,
} as IRecordTypeDefinition;
